var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Pipe } from '@angular/core';
var TruncatePipe = /** @class */ (function () {
    function TruncatePipe() {
    }
    TruncatePipe.prototype.transform = function (text, length) {
        var b = 0;
        for (var i = 0; i < text.length; i++) {
            b += text.charCodeAt(i) <= 255 ? 1 : 2;
            if (b > length) {
                return text.substr(0, i) + '…';
            }
        }
        return text;
    };
    TruncatePipe = __decorate([
        Pipe({
            name: 'truncate',
        })
    ], TruncatePipe);
    return TruncatePipe;
}());
export { TruncatePipe };
//# sourceMappingURL=truncate.js.map


// WEBPACK FOOTER //
// ./src/pipes/truncate/truncate.ts.pre-build-optimizer.js